import clsx from 'clsx';
import { Link } from 'react-router-dom';
import ReportsSVG from '../../assets/icons/reports.svg';
import ScheduleSVG from '../../assets/icons/schedule.svg';
import BookSVG from '../../assets/icons/book.svg';
import UserSVG from '../../assets/icons/user.svg';
import MoneySVG from '../../assets/icons/money.svg';
import { Button } from '../../components/Button';
import { PageWrapper } from '../../components/PageWrapper';
import { useAppSelector } from '../../hooks';
import { UserRole } from '../../services/api.types';
import { ROUTES } from '../../utils/constants';
import { CJRLogo, LogoPositions } from '../../components/CJRLogo';

type HomeOptionProps = {
  text: string;
  icon: string;
  alt?: string;
  to: string;
  onClick?: () => void;
};

const HomeOption = ({ text, icon, alt, to, onClick }: HomeOptionProps) => {
  return (
    <Link
      className={clsx(
        'flex flex-col items-center',
        'group hover:cursor-pointer',
        'no-underline'
      )}
      to={to}
    >
      <Button
        className={clsx(
          'flex justify-center items-center',
          'w-44 h-44 rounded-full',
          'bg-white group-hover:bg-orange-primary',
          'transition duration-300'
        )}
        onClick={onClick}
      >
        <img src={icon} alt={alt ?? text} width={24} height={24} />
      </Button>

      <p className="text-15 my-1 text-blue-primary">{text}</p>
    </Link>
  );
};

export const HomePage = () => {
  const user = useAppSelector((state) => state.user);
  if (!user) return null;
  const userRole = user.role;
  return (
    <>
      <PageWrapper>
        <div
          className={clsx(
            'flex flex-row flex-wrap',
            'justify-center items-center',
            'w-full my-auto gap-8'
          )}
        >
          {(userRole === UserRole.ADMIN || userRole === UserRole.EMPLOYEE) && (
            <>
              <HomeOption
                to={ROUTES.calendars.index}
                text="Agenda"
                icon={ScheduleSVG}
              />
              <HomeOption
                to={ROUTES.users.index}
                text="Usuários"
                icon={UserSVG}
              />
              <HomeOption
                to={ROUTES.reports.index}
                text="Relatórios"
                icon={ReportsSVG}
              />
              <HomeOption
                to={ROUTES.subjects.index}
                text="Matérias"
                icon={BookSVG}
              />
              <HomeOption
                to={ROUTES.payments.index}
                text="Financeiro"
                icon={MoneySVG}
              />
            </>
          )}

          {userRole === UserRole.STUDENT && (
            <>
              <HomeOption
                to={ROUTES.calendars.index}
                text="Agenda"
                icon={ScheduleSVG}
              />
            </>
          )}

          {userRole === UserRole.RESPONSIBLE && (
            <>
              <HomeOption
                to={ROUTES.calendars.index}
                text="Agenda"
                icon={ScheduleSVG}
              />
              <HomeOption
                to={ROUTES.payments.index}
                text="Financeiro"
                icon={MoneySVG}
              />
            </>
          )}

          {userRole === UserRole.TEACHER && (
            <>
              <HomeOption
                to={ROUTES.calendars.index}
                text="Agenda"
                icon={ScheduleSVG}
              />
              <HomeOption
                to={ROUTES.reports.index}
                text="Relatório das Aulas"
                icon={ReportsSVG}
              />
            </>
          )}
        </div>
      </PageWrapper>
      <CJRLogo logoPosition={LogoPositions.HOME} />
    </>
  );
};
